<template>
  <div id="maynekman">
    <div class="container-marcas">
      <div class="banner">
        <!-- <img src="@/assets/images/duraznoMaynek.png" alt="Uva"> -->
        <div class="titulo">
          <p>MAYNEKMAN</p>
        </div>
      </div>
      <div class="desc">
        <p class="bold">
          La compañía mas joven, con un gran presente y un mejor futuro, se constituyó como empresa
          el 6 de diciembre de 2007
        </p>
        <p>
          Maynekman SA de CV ha sido la punta de lanza para el crecimiento del Grupo MLA en la
          región Occidente del país, ubicada en el Mercado de Abasto
          de la ciudad de Guadalajara, Jalisco.
        </p>
        <p>
          Orgullo de Grupo MLA por mantenerse dentro de los estándares de calidad y productividad de
          las empresas del Grupo, pone a su disposición todos los recursos humanos para brindarle a
          usted la atencion que se merece.
        </p>
      </div>
      <div class="fotos">
        <h1 class="tl">Matriz</h1>
        <div class="flex">
          <div class="foto">
            <img src="@/assets/images/maynekman/matriz.jpg" alt="Galeria">
          </div>
          <div class="foto">
            <img src="@/assets/images/maynekman/matriz-2.jpg" alt="Galeria">
          </div>
          <div class="foto">
            <img src="@/assets/images/maynekman/matriz-3.jpg" alt="Galeria">
          </div>
          <div class="foto">
            <img src="@/assets/images/maynekman/matriz-4.jpg" alt="Galeria">
          </div>
        </div>
      </div>
      <div class="fotos">
        <h1 class="tl">Sucursal</h1>
        <div class="flex">
          <div class="foto">
            <img src="@/assets/images/maynekman/sucursal.jpg" alt="Galeria">
          </div>
          <div class="foto">
            <img src="@/assets/images/maynekman/sucursal-2.jpg" alt="Galeria">
          </div>
          <div class="foto">
            <img src="@/assets/images/maynekman/sucursal-3.jpg" alt="Galeria">
          </div>
          <div class="foto">
            <img src="@/assets/images/maynekman/sucursal-4.jpg" alt="Galeria">
          </div>
        </div>
        <div class="flex">
          <div class="foto w-25">
            <img class="w-100" src="@/assets/images/maynekman/flotilla-noche.png" alt="Galeria">
          </div>
          <div class="foto w-50">
            <img class="w-100" src="@/assets/images/maynekman/flotilla.png" alt="Galeria">
          </div>
          <div class="foto w-25">
            <img class="w-100" src="@/assets/images/maynekman/centro-de-carga.png" alt="Galeria">
          </div>
        </div>
      </div>
      <div class="ubicacion">
        <div class="flex-ubi">
          <div class="map">
          <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d933.3357645436297!2d-103.38328366449143!3d20.65561757322048!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xdfb5fa123788b7c9!2sMAYNEKMAN!5e0!3m2!1ses-419!2smx!4v1547223025765"
          width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen></iframe>
          </div>
          <div class="direccion">
            <p class="bold">Maynekman, S.A. de C.V.</p>
            <p>Calle 4 núm. 2599</p>
            <p>Entre Trigo y Mandarina</p>
            <p>Mercado de Abastos</p>
            <p>44530, Guadalajara, Jalisco, Mexico</p>
            <p>Conmutador: [5233] 3884 1620</p>
            <p>t. [5233] 3671 0680</p>
            <p>y [5233] 3671 2940</p>
            <p class="underline">cobranza@grupomla.com.mx</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
#maynekman {
//    p {
//     font-size: 1.3em;
//   }
  .container-marcas {
    .banner {
      background: url('../../assets/images/maynekman2.png');
      background-position: center;
      background-size: cover;
      height: 80vh;
      width: 100%;
      position: relative;

      img {
        z-index: 1;
        width: 100%;
        height: 100%;
      }

      .titulo {
        position: absolute;
        color: #fff;
        font-size: 2.2em;
        font-weight: bold;
        top: 5%;
        left: 4%;
      }

    }
    .desc {
      font-size: 1.3em;
      padding: 0 10%;
      padding-bottom: 50px;
      margin-bottom: 50px;

      .bold {
        font-weight: bold;
      }

    }
    .fotos {
      width: 90%;
      margin: 0 auto;
      margin-bottom: 50px;

      .flex {
        display: flex;

        .foto {
          margin: 10px 10px;;
        }
      }

    }
    .ubicacion {
      width: 80%;
      margin: 0 auto;

      .flex-ubi {
        height: 70vh;
        display: flex;
        justify-content: center;

        .map {
          width: 50%;
        }
        .direccion {
          width: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          line-height: 5px;


          .bold {
            font-weight: bold;
          }

          .underline {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
